export interface AssistantAccess {
  user?: { role?: string };
  currentApp?: { suiteOptions?: { assistant?: boolean } };
}

export function canUseAssistant(session: AssistantAccess): boolean {
  return session.user?.role === 'burt_admin' || !!session.currentApp?.suiteOptions?.assistant;
}
